<template>
  <div>
    <div class="sign-up-title text-center mb-2">
      Invite your team members
    </div>
    <div class="sign-up-subtitle-sm text-center mb-5">
      Please note that you can only invite {{maxInvitations}} people on your team on our free plan
    </div>
    <invitation-form
      :max-invitations="maxInvitations"
      :submitting="submitting"
      @back="$emit('back')"
      @skip="$emit('skip')"
      @submit="onSubmit"
      @preview-invite="onPreviewInvite"
      @invite-link="onInviteLink"
    />
    <b-modal ref="preview" hide-footer size="xl" body-class="p-0" title="Preview invitation">
      <template v-if="!loadingPreview">
        <b-overlay opacity="0" show>
          <iframe
            :srcdoc="preview.previewHtml"
            width="100%"
            height="100%"
            frameborder="0"
            @load="onLoadFrame"
          />
          <template v-slot:overlay>
            <div />
          </template>
        </b-overlay>
      </template>
      <div v-else class="text-center p-5">
        <b-spinner variant="primary" label="Loading..." />
      </div>
    </b-modal>
    <b-modal ref="invitelink" size="lg" title="Invite link">
      <b-form-row v-if="!gettingLink" class="align-items-center">
        <b-col>
          <b-form-input ref="inviteLink" v-focus v-model="invitationLink" readonly class="rounded-pill" @focus="onFocus" />
        </b-col>
        <b-col cols="1">
          <b-button variant="link" class="btn-link-primary p-0" @click.prevent="onCopyInviteLink">
            <b-icon-files font-scale="1.5" />
          </b-button>
        </b-col>
      </b-form-row>
      <div v-else>
        <b-spinner variant="primary" label="Loading..." />
      </div>
      <template v-slot:modal-footer="{ hide }">
        <b-button variant="primary" @click="hide()">
          Close
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import InvitationForm from '@/components/forms/CreateProfile/InvitationForm.vue'

export default {
  name: 'Invitations',

  props: {
    submitting: {
      type: Boolean,
      default: false
    },

    team: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      maxInvitations: 20,
      preview: { previewHtml: '' },
      loadingPreview: false,
      invitationLink: null,
      gettingLink: false
    }
  },

  methods: {
    async loadPreviewInvitation() {
      this.loadingPreview = true
      try {
        this.preview = await this.$store.dispatch('previewUserInvitation', this.team.name)
      } finally {
        this.loadingPreview = false
      }
    },

    onFocus({ target }) {
      target.select()
      target.setSelectionRange(0, target.value.length)
    },

    onCopyInviteLink() {
      const input = this.$refs.inviteLink.$el
      input.select()
      input.setSelectionRange(0, input.value.length)
      document.execCommand('copy')
    },

    onInviteLink() {
      this.$refs.invitelink.show()
      this.gettingLink = true
      this.$store.dispatch('getInvitationLink', this.team.id)
        .then(({ link }) => (this.invitationLink = link))
        .finally(() => (this.gettingLink = false))
    },

    onPreviewInvite() {
      this.$refs.preview.show()
      this.loadPreviewInvitation()
    },

    onLoadFrame({ target }) {
      target.height = target.contentWindow.document.body.scrollHeight + 100
    },

    onSkip() {
      this.$store.dispatch('signup/clearInvitations')
        .then(() => this.$emit('skip'))
    },

    onSubmit(data) {
      this.$store.dispatch('signup/createInvitations', data.emails)
        .then(() => this.$emit('submitted'))
    }
  },

  components: {
    InvitationForm
  }
}
</script>
